import withEventTriggering from '../../utils/with-events-triggering';
import provideEachCallEvents from '../../utils/provide-each-call-events';

import initFile from './file';
import initPremium from './premium';
import initList from './list';
import initLists from './lists';
import initItem from './item';
import initItems from './items';
import initListItems from './list-items';
import initSettings from './settings';
import initAutocomplete from './autocomplete';

import createPrivateMedia from '../../utils/wix-private-media';

import events from './events/index';
import channels from './channels/channels';

import defaultSettings from './default-settings';

function addEventsTriggering(methodsGroups) {
  _.forEach(methodsGroups, function (methods, groupName) {
    groupName = _.snakeCase(groupName).toUpperCase();
    _.forEach(methods, function (method, key) {
      const name = _.snakeCase(key).toUpperCase();
      methods[key] = withEventTriggering(method, `VOD.${groupName}.${name}`);
    });
  });
}

function wrapWithEventsProviding(methodsGroups, globalTrigger) {
  return _.mapValues(methodsGroups, function (methods) {
    return _.mapValues(methods, function (method) {
      return provideEachCallEvents(method, globalTrigger);
    });
  });
}

export default function VOD(userSettings) {
  const _settings = _.assign({}, defaultSettings, userSettings);
  const wixPrivateMedia = createPrivateMedia(_settings);
  channels.setup({ wixPrivateMedia });

  const methodsGroups = {};
  methodsGroups.file = initFile(_settings, methodsGroups);
  methodsGroups.premium = initPremium(_settings, methodsGroups);
  methodsGroups.list = initList(_settings, methodsGroups);
  methodsGroups.lists = initLists(_settings, methodsGroups);
  methodsGroups.item = initItem(_settings, methodsGroups);
  methodsGroups.items = initItems(_settings, methodsGroups);
  methodsGroups.listItems = initListItems(_settings, methodsGroups);
  methodsGroups.settings = initSettings(_settings, methodsGroups);
  methodsGroups.autocomplete = initAutocomplete(_settings, methodsGroups);
  addEventsTriggering(methodsGroups);

  _.assign(
    this,
    { events },
    wrapWithEventsProviding(methodsGroups, (...args) => events.trigger(...args))
  );
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/index.js